export var CookieKeys = {
    darkMode: "darkMode",
    isDaily: "isDaily",
    colorblindAssist: "colorblindAssist",
};
export var Expires = {
    YEAR: 60 * 60 * 24 * 365,
    HOUR: 60 * 60,
};
